import React, { Component } from 'react';
import './style.css';
import { Link } from "react-router-dom";
import Header from './../../header/header';
import Footer from './../../footer/footer';
import { horoscopeName_en, horoscopeDate_en } from './../../../../utils/horoscope_en';
import { horoscopeName_es, horoscopeDate_es } from './../../../../utils/horoscope_es';
import { horoscopeName_gr, horoscopeDate_gr } from './../../../../utils/horoscope_gr';
import { horoscopeName_ee, horoscopeDate_ee } from './../../../../utils/horoscope_ee';
import { horoscopeName_nl, horoscopeDate_nl } from './../../../../utils/horoscope_nl';
import { horoscopeName_fr, horoscopeDate_fr } from './../../../../utils/horoscope_fr';
import { horoscopeName_ar, horoscopeDate_ar } from './../../../../utils/horoscope_ar';
import { horoscopeName_hu, horoscopeDate_hu } from './../../../../utils/horoscope_hu';

import Tarot from './../tarot/tarot';
import TarotHoroscrpe from './../TarotHoroscrpe/tarotHoroscrpe';
import Coffeecupsection from './../coffeecupreading/coffeeCupSection'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Particle from './../../../../utils/particle';
import './../../../assets/css/style.css';
import { sendData } from '../../../../analytics/sendData';

class Horoscopes extends Component {
    getCountry = () => {
        if (window.location.hostname == 'es.mobioastro.com') {
            return 'mexico';
        } else if (window.location.hostname == 'localhost') {
            return 'mexico';
        } else {
            '';
        }
    }
    horoscopeList =     () => {
        let horoscopeName = [], horoscopeDate = [];
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        console.log("countryCode",typeof(countryCode.countryCode))
        if (countryCode.countryCode === 'es' || countryCode.countryCode === 'mx') {
            console.log("test")
            horoscopeName = horoscopeName_es;
            horoscopeDate = horoscopeDate_es;
        } else if (countryCode.countryCode === 'gr'){
            horoscopeName = horoscopeName_gr;
            horoscopeDate = horoscopeDate_gr;
        }else if (countryCode.countryCode === 'ee'){
            horoscopeName = horoscopeName_ee;
            horoscopeDate = horoscopeDate_ee;
        }else if (countryCode.countryCode === 'nl'){
            horoscopeName = horoscopeName_nl;
            horoscopeDate = horoscopeDate_nl;
        }
        else if (countryCode.countryCode === 'fr'){
            horoscopeName = horoscopeName_fr;
            horoscopeDate = horoscopeDate_fr;
        }
        else if (countryCode.countryCode === 'eg'){
            horoscopeName = horoscopeName_ar;
            horoscopeDate = horoscopeDate_ar;
        }
        else if (countryCode.countryCode === 'hu'){
            horoscopeName = horoscopeName_hu;
            horoscopeDate = horoscopeDate_hu;
        }
        else {
            horoscopeName = horoscopeName_en;
            horoscopeDate = horoscopeDate_en;
        }
        return (
            <div className="checkastronow-box-items">
                {
                    horoscopeName.map((rowData, index) => {
                        return (
                            <div className="item" key={index}>
                                <Link to={{ pathname: '/horoscopeDetail', state: { id: (index) } }}>
                                    <div className="item-img"> <img src={require('./../../../assets/images/horoscopes/horoscope-icon-' + (index) + '.png')} alt="" /></div>
                                    <div className="item-caption">
                                        <p className="text-bold">{rowData}</p>
                                        <p className="offset-top-0">{horoscopeDate[index]}</p>
                                    </div>
                                </Link>
                            </div>
                        )

                    })
                }
            </div>
        )

    }
    render() {
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        return (
            <div className="page">
                {/* <Header /> */}
                <div className="combine-section">
                    <TarotHoroscrpe />
                </div>
                <div className="margin-horoscope" id="horoscope-reading">
                    <div className="shell text-center">
                        <div className="range range-xs-center">
                            <div className="cell-xs-12" >
                                <h2><FormattedMessage id="main.horoscope.checkastronowtitle"
                                    defaultMessage="Horoscope Reading"
                                    description=""
                                    values={{}} /></h2>
                            </div>
                            <div className="cell-xs-12 checkastronow-horoscope-subtitle" >
                                <h3><FormattedMessage id="main.horoscope.checkastronowtitlesubtitle"
                                    defaultMessage="Our horoscopes can help you find a proper approach to solving all daily proplems and achieving happiness in your life."
                                    description=""
                                    values={{}} /></h3>
                            </div>
                            <div className="cell-xs-12 cell-md-9 offset-top-30" style={{ marginTop: '30px' }}>
                                {this.horoscopeList()}
                            </div>
                        </div>
                    </div>
                </div>
                <Tarot />
                {/* {countryCode.countryCode==='gr' ?
                <div className='margin-bottom-coffee'>
                    <Coffeecupsection />
                </div>:null
                } */}
                
                <Footer country={countryCode.countryCode} />
            </div>
        );
    }
}

export default Horoscopes;



// WEBPACK FOOTER //
// ./src/checkastronow/components/screens/horoscopes/horoscopes.js